import React from 'react';
import { TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import PhoneNumberInput from 'common-mui/components/PhoneNumberInput';

export const transform = (v) => v.replace(/[^\d+]/g, '');

const InputPhone = ({ prefill }) => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="phone"
      control={control}
      defaultValue={prefill?.slice(2)}
      rules={{
        required: 'This field is required.',
        // Pattern matching handles format
        // so we only need to check length.
        validate: (v) => transform(v).length === 12 || 'Please enter a valid phone number',
      }}
    >
      <TextField
        fullWidth
        label="Mobile Number"
        InputProps={{ inputComponent: PhoneNumberInput }}
      />
    </ValidatedTextField>
  );
};

export default InputPhone;
